import React, { useState } from "react";
import { useEndpointHook } from "../../../hooks/useEndpointHook";
import { useDispatch, useSelector } from "react-redux";
import { financingRequestsClear } from "../../../redux/reducers/financingRequestsReducer";
import Flx from "../../layout/Flx";
import FileUploadFieldWithModal from "../../common/FileUploadFieldWithModal";
import { grey } from "@mui/material/colors";
import { Box } from "@mui/material";
import BasicFilesTable from "../../tables/BasicFilesTable";

const FinancingRequestFilesTab = ({ dealId, loanDocuments }) => {
  const [uploadedFiles, setUploadedFiles] = useState(null);
  const { loading, uploadFilesToLoan } = useEndpointHook();
  const profile = useSelector((state) => state?.profile);
  const dispatch = useDispatch();

  const handleOnSubmit = (f) => {
    console.log("SUBMITTT", f);

    // return;
    uploadFilesToLoan({
      dealId: dealId,
      files: f,
      onSuccessFn: () => {
        setUploadedFiles(null);
        dispatch(financingRequestsClear());
      },
    });
  };
  return (
    <Flx column g={1.5}>
      <FileUploadFieldWithModal
        suppressUploadButton
        borderSize={1.5}
        minHeight={"88px"}
        keyName={`file-uploader-card-${dealId}`}
        onSubmit={handleOnSubmit}
        loading={loading}
        inputSx={{ background: grey[50] }}
        files={uploadedFiles}
        setFiles={setUploadedFiles}
      />

      <Box
        sx={{
          maxHeight: "800px",
          overflowY: "auto",
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderRadius: "8px",
          ".ag-row-last": {
            borderBottom: "none !important",
          },
          ".ag-header-viewport": {
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          },
        }}
      >
        <BasicFilesTable
          headerHeight={50}
          showStatus
          showUploadDate
          files={loanDocuments}
        />
      </Box>
    </Flx>
  );
};
export default FinancingRequestFilesTab;
